import {useDispatch} from "react-redux";
import {useAppSelector} from "../../app/store";
import {useParams} from "react-router-dom";
import React, {useEffect} from "react";
import {getUser} from "../../app/slices/adminUserView";
import {Button, Col, Container, Row} from "react-bootstrap";
import AdminLoader from "./AdminLoader";
import {ADMIN_LANG, CHANGE_USER} from "../../settings";
import {openModal} from "../../app/slices/modals/userModal";
import {CheckCircleFill, XCircleFill} from "react-bootstrap-icons";
import SessionTable from "./SessionTable";
import EventTable from "./EventTable";
import {formatDate, formatRelativeDate} from "./utils";
import ErrorPage from "./ErrorPage";


const UserView = () => {
    const dispatch = useDispatch();
    const {
        loaded,
        error,
        is_active,
        is_staff,
        first_name,
        last_name,
        email,
        teams,
        sessions,
        events,
        last_seen,
        date_joined,
        is_superuser
    } = useAppSelector(state => state.adminUserView);

    const {permissions} = useAppSelector(state => state.profile);

    const {user_id} = useParams();

    useEffect(() => {
        // NOTE: on React.StrictMode, this useEffect is called twice on dev mode
        if (user_id) {
            dispatch(getUser(user_id));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user_id]);

    const handleEditUser = () => {
        if (user_id) dispatch(openModal({user_id}));
    }

    if(error) {
        return(
            <ErrorPage message={error} />
        )
    }

    return (
        <Container className='pt-4'>
            {!loaded && <AdminLoader/>}
            <Row className='gy-4'>
                <Col xs={12}>
                    <Button disabled={!permissions.includes(CHANGE_USER)} variant='primary' onClick={handleEditUser}>{ADMIN_LANG.edit}</Button>
                </Col>
                <Col xs={12}>
                    <div className='admin-card small-p-margin'>
                        <h2>{first_name} {last_name}</h2>
                        <p><strong>{ADMIN_LANG.date_joined}: </strong>{date_joined ? formatDate(date_joined) : ''}</p>
                        <p><strong>{ADMIN_LANG.last_seen}: </strong>{last_seen ? formatRelativeDate(last_seen) : ''}</p>
                        <p><strong>{ADMIN_LANG.email}: </strong>{email}</p>
                        <p><strong>{ADMIN_LANG.is_active}: </strong> {is_active ?
                            <CheckCircleFill className="text-success"/> : <XCircleFill className="text-danger"/>}</p>
                        <p><strong>{ADMIN_LANG.is_staff}: </strong> {is_staff ?
                            <CheckCircleFill className="text-success"/> : <XCircleFill className="text-danger"/>}</p>
                        <p><strong>{ADMIN_LANG.is_superuser}: </strong> {is_superuser ?
                            <CheckCircleFill className="text-success"/> : <XCircleFill className="text-danger"/>}</p>
                        <p><strong>{ADMIN_LANG.teams}: </strong>
                            {teams.length > 0 ? (
                                teams.map((team, index) => (
                                    <span key={index} className="badge bg-secondary ms-2">
                                    {team.label}
                                    </span>
                                ))
                            ) : (
                                <span>{ADMIN_LANG.no_teams_selected}</span>
                            )}
                        </p></div>
                </Col>
                <Col xs={12}>
                    <div className='admin-card'>
                    <h3>{ADMIN_LANG.latest_sessions}</h3>
                        <SessionTable sessions={sessions} />
                    </div>
                </Col>
                <Col xs={12}>
                    <div className='admin-card'>
                        <h3>{ADMIN_LANG.latest_events}</h3>
                        <EventTable events={events} />
                    </div>
                </Col>
            </Row>
        </Container>
    );
}
export default UserView;